import React from "react";
import { Box } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import TypewriterHeader from "../components/TypewriterHeader";
import PostList from "../components/PostList";
import blogTheme from "../theme/blogTheme";

const BlogProjects = () => (
  <Box p={{ xs: 1, sm: 2 }}>
    {/* TypewriterHeader lives outside the nested ThemeProvider so it keeps
        the VS Code colour scheme defined in vsDarkTheme (the component reads
        that theme directly, not from context). */}
    <TypewriterHeader title="Blog" speed={80} delay={200} />

    {/* Scope blogTheme only to the post list zone. The subtle border-radius
        and padding create a soft visual transition instead of an abrupt cut. */}
    <ThemeProvider theme={blogTheme}>
      <Box
        sx={{
          mt: 2,
          p: { xs: 1.5, sm: 2.5 },
          backgroundColor: "background.default",
          borderRadius: 2,
        }}
      >
        <PostList />
      </Box>
    </ThemeProvider>
  </Box>
);

export default BlogProjects;
